import { MensagemAlertAcesso } from "../UI/MensagemAlertAcesso";

type Props ={
    mensagem?:string
}


export const MensagemBloqueio: React.FC<Props> = ({ mensagem }) => {
    return <div className='wrapper d-flex flex-column flex-column-fluid' id='kt_wrapper'>
        <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
            {' '}
            <MensagemAlertAcesso mensagem={mensagem}>
                {' '}
            </MensagemAlertAcesso>
        </div>
    </div>;

}
